module.exports = __webpack_public_path__ + "assets/img/23_90.28a832f8.jpg";